/** 13 Shorts: labels on screen and for screen readers */
export const storiesHe = {
  rail: '13 שורטס',
  dialog: 'נגן 13 שורטס',
  close: 'סגירת הנגן',
  share: 'שיתוף',
  mute: 'השתקה',
  unmute: 'הפעלת סאונד',
  play: 'ניגון',
  pause: 'השהיה',
  nextClip: 'לחלק הבא',
  previousClip: 'לחלק הקודם',
  nextEpisode: 'לפרק הבא',
  previousEpisode: 'לפרק הקודם',
  newBadge: 'חדש',
  watched: 'נצפה',
  copied: 'הקישור הועתק ללוח',
  /** the copy failed: the link itself, for the user to copy */
  copyByHand: 'העתיקו את הקישור:',
  shareLink: 'קישור לשיתוף',
  ad: 'פרסומת',
  clipOf: (clip: number, total: number) => `חלק ${clip} מתוך ${total}`,
  progress: 'התקדמות בחלק',
  progressText: (time: string, total: string) => `${time} מתוך ${total}`,
  loading: 'טוען',
  /** outside Israel (D45): two lines, as drawn */
  geoBlock: ['התוכן אינו זמין בחו״ל.', 'עמכם הסליחה'],
  adBlock: {
    title: 'נראה שמשהו חוסם את התצוגה',
    intro:
      'כדי להמשיך ולהנות ממגוון התכנים שלנו, כבו בבקשה את חוסם הפרסומות בדפדפן.',
    causesTitle: 'בדרך כלל זה נגרם משתי סיבות:',
    causes: [
      { lead: 'חיבור האינטרנט - ', text: 'אולי הוא קצת איטי או "עייף" כרגע.' },
      {
        lead: 'חוסם פרסומות - ',
        text: 'אם יש לכם תוסף כזה פעיל, הוא עלול למנוע מהתוכן לעלות.',
      },
    ],
    fixTitle: 'איך מסדרים את זה?',
    fixes: [
      'כדאי לבדוק שהאינטרנט עובד ולרענן את העמוד.',
      'אם יש לכם חוסם פרסומות, נסו לכבות אותו לאתר הזה. לאחר מכן, לחצו על רענון והכל אמור לעבוד.',
    ],
  },
} as const
